import { createRouter, createWebHistory } from 'vue-router'
import axiosInstance from '../plugins/axios'
import AdminLogin from '../components/admin/AdminLogin.vue'
import AdminDashboard from '../components/admin/AdminDashboard.vue'
import AdminBooking from '@/components/admin/AdminBooking.vue'
import AdminRoutes from '@/components/admin/AdminRoutes.vue'
import AdminVehicles from '@/components/admin/AdminVehicles.vue'
import AdminTrips from '@/components/admin/AdminTrips.vue'
import AdminDiscountCodes from '@/components/admin/AdminDiscountCodes.vue'
import AdminOrders from '@/components/admin/AdminOrders.vue'
import AdminAddonProducts from '@/components/admin/AdminAddonProducts.vue'
import AdminBlockedPhones from '@/components/admin/AdminBlockedPhones.vue'
import AdminBatchEmail from '@/components/admin/AdminBatchEmail.vue'
import AdminGroupBookings from '@/components/admin/AdminGroupBookings.vue'
import AdminUsers from '@/components/admin/AdminUsers.vue'
import AdminInvoices from '@/components/admin/AdminInvoices.vue'
import AdminInvoiceConfig from '@/components/admin/AdminInvoiceConfig.vue'


const routes = [
  {
    path: '/',
    redirect: '/login'
  },
  {
    path: '/login',
    name: 'Login',
    component: AdminLogin
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: AdminDashboard,
    meta: { requiresAuth: true }
  },
  {
    path: '/bookings',
    name: 'Bookings',
    component: AdminBooking,
    meta: { requiresAuth: true }
  },
  {
    path: '/routes',
    name: 'Routes',
    component: AdminRoutes,
    meta: { requiresAuth: true }
  },
  {
    path: '/vehicles',
    name: 'Vehicles',
    component: AdminVehicles,
    meta: { requiresAuth: true }
  },
  {
    path: '/trips',
    name: 'Trips',
    component: AdminTrips,
    meta: { requiresAuth: true }
  },
  {
    path: '/session-expired',
    redirect: '/login'
  },
  {
    path: '/admin/discount-codes',
    name: 'AdminDiscountCodes',
    component: AdminDiscountCodes,
    meta: { requiresAuth: true }
  },
  {
    path: '/admin/addon-products',
    name: 'AdminAddonProducts',
    component: AdminAddonProducts,
    meta: { requiresAuth: true }
  },
  {
    path: '/orders',
    name: 'AdminOrders',
    component: AdminOrders,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/admin/blocked-phones',
    name: 'AdminBlockedPhones',
    component: AdminBlockedPhones,
    meta: { requiresAuth: true }
  },
  {
    path: '/admin/batch-email',
    name: 'AdminBatchEmail',
    component: AdminBatchEmail,
    meta: { requiresAuth: true }
  },
  {
    path: '/admin/group-bookings',
    name: 'AdminGroupBookings',
    component: AdminGroupBookings,
    meta: { requiresAuth: true }
  },
  {
    path: '/admin/users',
    name: 'AdminUsers',
    component: AdminUsers,
    meta: { requiresAuth: true }
  },
  {
    path: '/invoices',
    name: 'AdminInvoices',
    component: AdminInvoices,
    meta: { requiresAuth: true, adminOrAccountant: true }
  },
  {
    path: '/invoice-config',
    name: 'AdminInvoiceConfig',
    component: AdminInvoiceConfig,
    meta: { requiresAuth: true, adminOnly: true }
  },
]

const router = createRouter({
  history: createWebHistory(), // Remove process.env.BASE_URL
  routes
})

router.beforeEach(async (to, from, next) => {
  document.title = "Đi Chung Xe - Quản Trị";

  const favicon = document.querySelector('link[rel="icon"]') || document.createElement('link');
  favicon.type = 'image/x-icon';
  favicon.rel = 'icon';
  favicon.href = '/favicon.ico';
  if (!document.querySelector('link[rel="icon"]')) {
    document.head.appendChild(favicon);
  }

  // Nếu đang đi đến trang đăng nhập, cho phép
  if (to.path === '/login') {
    next();
    return;
  }
  if (to.path === '/session-expired') {
    return next('/login');
  }

  // Kiểm tra token
  let token = localStorage.getItem('adminToken');
  const refreshToken = localStorage.getItem('refreshToken');
  if (!token && !refreshToken) {
    // Không có token, chuyển hướng đến trang đăng nhập
    return next('/login');
  }

  try {
    let isExpired = true;
    if (token) {
      try {
        const payload = JSON.parse(atob(token.split('.')[1]));
        const expiry = payload.exp * 1000;
        if (Date.now() < expiry) {
          isExpired = false;
        }
      } catch {
        isExpired = true;
      }
    }

    // Token đã hết hạn -> Thử refresh ngầm
    if (isExpired) {
      if (refreshToken) {
        try {
          const response = await axiosInstance.post('/admin/refresh', {}, {
            headers: { Authorization: `Bearer ${refreshToken}` }
          });
          const { access_token, refresh_token } = response.data;
          localStorage.setItem('adminToken', access_token);
          localStorage.setItem('refreshToken', refresh_token);
          token = access_token;
        } catch (refreshErr) {
          localStorage.removeItem('adminToken');
          localStorage.removeItem('refreshToken');
          sessionStorage.setItem('session_expired_toast', '1');
          return next('/login');
        }
      } else {
        localStorage.removeItem('adminToken');
        localStorage.removeItem('refreshToken');
        sessionStorage.setItem('session_expired_toast', '1');
        return next('/login');
      }
    }
  } catch (error) {
    console.error('Lỗi khi phân tích token:', error);
    localStorage.removeItem('adminToken');
    localStorage.removeItem('refreshToken');
    sessionStorage.setItem('session_expired_toast', '1');
    return next('/login');
  }

  if (!token) {
    return next('/login');
  }

  // Token hợp lệ, check role-based guards
  const payload = JSON.parse(atob(token.split('.')[1]));

  if (to.meta.adminOnly && payload.role !== 'admin') {
    return next('/bookings');
  }
  if (to.meta.adminOrAccountant && !['admin', 'accountant'].includes(payload.role)) {
    return next('/bookings');
  }

  next();
});

export default router;